package br.com.texeratx.boardgametimeapp.ui.screens.home

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.active_match.ActiveMatchController
import br.com.texeratx.boardgametimeapp.core.active_match.ActiveMatchState
import br.com.texeratx.boardgametimeapp.ui.components.ReplaceActiveMatchDialog
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppScreenScaffold
import br.com.texeratx.boardgametimeapp.ui.screens.active_match.ActiveMatchScreen
import br.com.texeratx.boardgametimeapp.ui.screens.active_match.StartMatchSetupScreen
import br.com.texeratx.boardgametimeapp.ui.screens.clan.ClanScreen
import br.com.texeratx.boardgametimeapp.ui.screens.dashboard.DashboardScreen
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.list.ExpansionsScreen
import br.com.texeratx.boardgametimeapp.ui.screens.games.GameScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.MatchesScreen
import br.com.texeratx.boardgametimeapp.ui.screens.options.OptionsScreen
import br.com.texeratx.boardgametimeapp.ui.screens.players.PlayersScreen
import br.com.texeratx.boardgametimeapp.ui.screens.stats.StatsScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.getKoin

class HomeScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow

        val activeMatchController = getKoin().get<ActiveMatchController>()
        var showReplaceDialog by remember { mutableStateOf(false) }

        AppScreenScaffold(
            bottomBar = {
                HomeBottomBar(
                    onGames = { navigator.push(GameScreen()) },
                    onPlayers = { navigator.push(PlayersScreen()) },
                    onStartMatch = {
                        if (activeMatchController.hasRunningOrPausedMatch()) {
                            showReplaceDialog = true
                        } else {
                            navigator.push(StartMatchSetupScreen())
                        }
                    },
                    onMatches = { navigator.push(MatchesScreen()) },
                    onExpansions = { navigator.push(ExpansionsScreen()) },
                    onOptions = { navigator.push(OptionsScreen()) },
                    onStats = { navigator.push(StatsScreen()) },
                    onClan = { navigator.push(ClanScreen()) },
                )
            }
        ) { padding ->
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(padding)
            ) {
                DashboardScreen().Content()

                if (showReplaceDialog) {
                    ReplaceActiveMatchDialog(
                        onDismiss = { showReplaceDialog = false },
                        onContinueCurrent = {
                            showReplaceDialog = false
                            navigator.push(ActiveMatchScreen())
                        },
                        onReplace = {
                            showReplaceDialog = false
                            activeMatchController.clear()
                            navigator.push(StartMatchSetupScreen())
                        }
                    )
                }
            }
        }
    }
}

@Composable
private fun ActiveMatchShortcutCard(
    state: ActiveMatchState,
    onOpen: () -> Unit
) {
    val title = when (state) {
        is ActiveMatchState.Running -> "Partida em andamento"
        is ActiveMatchState.Paused -> "Partida pausada"
        is ActiveMatchState.Finished -> "Partida finalizada"
        else -> "Partida ativa"
    }

    val subtitle = when (state) {
        is ActiveMatchState.Running -> state.formattedElapsed
        is ActiveMatchState.Paused -> state.formattedElapsed
        is ActiveMatchState.Finished -> state.formattedElapsed
        else -> ""
    }

    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.secondaryContainer,
            contentColor = MaterialTheme.colorScheme.onSecondaryContainer
        )
    ) {
        Column(modifier = Modifier.padding(14.dp)) {
            Text(
                text = title,
                style = MaterialTheme.typography.titleMedium
            )

            if (subtitle.isNotBlank()) {
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = "Tempo: $subtitle",
                    style = MaterialTheme.typography.bodyMedium
                )
            }

            Spacer(modifier = Modifier.height(10.dp))

            Button(
                onClick = onOpen,
                modifier = Modifier.fillMaxWidth()
            ) {
                Text("Abrir partida")
            }
        }
    }
}
